/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';

import store from 'features/store';
import { Form, Button, Modal, Spinner } from 'react-bootstrap';

import { MyAccountMenuList, removeSideBar, ToggleSideBar } from '../MyAccountMenuList';
import Validators from 'shared/validators';

import { ArrayValueReorder, mobileNumberFormat } from 'shared/modifiers';
import authService from 'shared/services/authService';
import { connect } from 'react-redux';
import { IMAGE_TYPES } from 'shared/settings/config';
import { logout, setUser } from 'shared/settings/auth';
import { userImage } from 'shared/images/images';
import { getEditorDefaults, circleCropMask, setEditorPlugins } from 'shared/doka';
import { DokaImageEditor } from 'react-doka';

import './PersonalInfo.scss';
import { CityAndStateService, MyAccountService } from 'shared/services';
import { ToasterMessage } from 'shared/toast/toast';
import PersonalInfoService from 'shared/services/PersonalInfoService';
import { shippingAddressDelete, shippingAddressList,bannedwords } from 'shared/settings/apiconfig';
import { Datatable } from 'shared/datatable/Datatable';
import axios from 'axios';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';
import {DebounceInput} from 'react-debounce-input';
import moment from 'moment';
import { pmAutoNavigateToNextScreen } from 'shared/utils/utils';
import { Loader } from 'shared/hoc/loader/Loader';

/* initializes doka editor plugins */
setEditorPlugins();

/**


@Author Karthik

@param

@return html code for personal info

**/

class PersonalInfo extends Component {

    previousProfile = this.props.user;

    constructor(props) {
        super(props);
        this.timeoutInterval = null;
        this.toasterMessage = createRef();
        this.toasterMessageForNewEmail = createRef();
        this.toasterMessageForNewMobile = createRef();
        this.shippingMessage = createRef();

        this.state = {

            // image
            profileImage: {
                modal: false,
                imgSrc: null,
                tempImg: null
            },

            // form
            peronalInfoForm: {
                firstName: { value: '', error: '', validators: [Validators.required(), Validators.maxLength(45)], valid: true },
                lastName: { value: '', error: '', validators: [Validators.required(), Validators.maxLength(45)], valid: true }, 
                nickname: { value: '', error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, 'User Name')], valid: true },
                email: { value: '', error: '', validators: [Validators.required(), Validators.email()], valid: true },
                mobile: { value: '', error: '', validators: [Validators.required(), Validators.mobile(), Validators.maxLength(15)], valid: true },
                zipcode: { value: '', error: '', validators: [Validators.equalToLength(5)], valid: true },
                state: { value: '', error: '', validators: [Validators.required()], valid: true },
                city: { value: '', error: '', validators: [Validators.required(), Validators.maxLength(45)], valid: true },
                address1: { value: '', error: '', validators: [Validators.required(), Validators.maxLength(80)], valid: true },
                address2: { value: '', error: '', validators: [Validators.maxLength(80)], valid: true },
                contact: { value: '', error: '', validators: [], valid: true }
            },
            peronalInfoFormValid: false,
            pageLoading: true,
            mobileNumberVerify: '',
            loading: false,

            // City and state list
            stateList: [],
            cityList: [],
            prfileUpdate: { type: 'success', message: 'Saved', show: false },

            // change email
            newEmail: { value: '', error: '', validators: [Validators.required(), Validators.email()] },
            emailModal: false,
            unverifiedemail: null,
            emailverified: 0,
            isemailchanged: true,
            emailLoading: false,
            verifyLoading: false,
            nomarketingemail: 0,
            // checkBoxValue: 0,
            //change mobile number
            mobile: {
                newMobile: { value: '', error: '', validators: [Validators.required(), Validators.mobile()] },
                otp: { value: '', error: '', validators: [] },
                valid: false
            },
            isOtpSent: false,
            mobileModal: false,
            getOtpType: null,

            //profile status
            profileStatus: { show: false, type: '', message: '' },

            // Loader handling
            loaderHandle: null,
            resendOtp: false,

            // Handle mobile
            dontEdit: true,

            // Shpping form
            shippingForm: this.getShippingForm(),
            shippingFormValid: false,

            // Shipping modal
            shippingModal: false,
            showShippingErrorModal: false,
            showShippingErrorMessage: '',
            stateCityError: '',
            cityStateIsValid: true,
            shippingStateCityError: '',
            shippingCityStateIsValid: true,
            cityDropdownValue: [],
            showCityDropdown: false,
            shippingCityDropdownValue: [],
            shippingShowCityDropdown: false,
            isSaveDisable: true,
            nickNameChangedDate: false,
            showAppleid: false,
            showFacebookid: false,
            showGoogleid : false,
            apiLoading: false,
            profileBtnDisable: false,

            showProfileAddressValidateModal: false,
            selectedAddress: "entered",
            profileRecommendedAddress: {
                address1: { value: '' },
                address2: { value: '' },
                state: { value: '' },
                city: { value: '' },
                zipcode: { value: '' }
            },
            showAddressError: false,

            showShippingAddressValidateModal: false,
            shippingSelectedAddress: "entered",
            shippingRecommendedAddress: {
                address1: { value: '' },
                address2: { value: '' },
                state: { value: '' },
                city: { value: '' },
                zipcode: { value: '' }
            },
            showShippingAddressError: false,
            errorMsg: ''
        };

        this.errorMessage = "The Zip code, State and City not matching please enter correct information"
        
        this.addressErrorMessage = "Your address does not meet our requirements. Please call or email CTBids Help if you have any questions. -844-424-3435 -CTBIDSHelp@CaringTransitions.com"

        this.profileData = null;
        this.customEditorDefaults = {
            imageCropAspectRatio: 1,
            cropEnableSelectPreset: false,
            imageCropMinSize: { width: 130, height: 130 },
            willRenderCanvas: (shapes, state) => circleCropMask(shapes, state)
        };

        this.dataTable = createRef();
        this.headerButtonRef = createRef();
        this.config = {
            url: `${shippingAddressList}`,
            params: {},
            columns: [
                
                { name: 'Default Shipping Address', property: 'shipping', width: '160px', columnType: 'custom', customColumn: this.customRadioButton },
                { name: 'Address Type', property: 'addresstype', width: '160px' },
                { name: 'Address1', property: 'address1', width: '160px' },
                { name: 'Address2', property: 'address2', width: '160px' },
                {
                    name: '', property: 'addressid', columnType: 'actions', actions: ['edit', 'delete'], customHeader: <></>, width: '100px', 
                    actionEvents: {  edit: (row) => { this.setShippingForm(row, true) }, delete: (row) => { this.deleteShippingAddress(row) } }
                },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: '', width: '10px',
                    accordion: this.accordionValue
                }
            ],
            sort: [{ field: 'shipping', direction: 'desc' }],
            pagination: true,
            service: 'BUYER'
        };

        this.isEditShipping = false;
    }

    componentDidMount() {
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: false } });
        this.windowResizeHandle();
        window.addEventListener('resize', this.windowResizeHandle);
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "PersonalInfo" } });
        this.getProfileData();
    }

    componentDidUpdate() {
        // store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: MyAccountMenuList(), withSpan: true } });
        window.addEventListener('resize', this.windowResizeHandle);
            if (this.headerButtonRef && this.headerButtonRef.current) {
                if (this.props.user.profilecompleted) {
                    this.headerButtonRef.current.removeAttribute("disabled");
                } else {
                    this.headerButtonRef.current.setAttribute("disabled", true);
                }
                
            }
    }

    /* get user profile data */
    getProfileData = () => {
        authService.getUserDetails(this.props.user.id)
            .then(response => {
                CityAndStateService.getStateList().then(
                    stateList => {
                        const tempStateList = ArrayValueReorder(stateList.data.data, 'state');
                        this.profileData = { ...response.data.data[0] };
                        // let checkBoxValue = this.profileData.nomarketingemail
                        // this.setState({
                        //     checkBoxValue: checkBoxValue
                        // })
                        store.dispatch({ type: 'SET_USER', payload: { ...this.props.user, profilecompleted: this.profileData.profilecompleted }});
                        const requiredFields = ['zipcode', 'country', 'state', 'city', 'address1', 'mobile'];
                        let isValid = true;
                        requiredFields.forEach(x => {
                            if (!this.profileData[x]) {
                                isValid = false;
                            }
                        });
                        if (this.profileData.state) {
                            CityAndStateService.getCityList(this.profileData.state).then(
                                cityList => {
                                    const tempCityList = ArrayValueReorder(cityList.data.data, 'city');
                                    this.updateForm(tempStateList, isValid, tempCityList);
                                }
                            ).catch(error => error);
                        } else {
                            this.updateForm(tempStateList, isValid, []);
                        }
                    }
                ).catch(error => {
                    // TODO: Error message handle
                    this.setState({ pageLoading: false });
                });
            })
            .catch(error => {
                // TODO: Error message handle
                if (error?.status === 401) {
                    store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
                    logout(this.props.history, false);
                    removeSideBar();
                } else {
                    this.setState({ pageLoading: false });
                }
            });

    };

    updateForm = (stateList, isValid, cityList) => {
        this.setState({
            peronalInfoForm: {
                ...this.state.peronalInfoForm,
                firstName: { ...this.state.peronalInfoForm.firstName, value: this.profileData.firstname },
                lastName: { ...this.state.peronalInfoForm.lastName, value: this.profileData.lastname },
                nickname: { ...this.state.peronalInfoForm.nickname, value: this.profileData.nickname, error: this.validateName(this.profileData.nickname) },
                email: { ...this.state.peronalInfoForm.email, value: this.profileData.email },
                mobile: { ...this.state.peronalInfoForm.mobile, value: this.profileData.mobile ? mobileNumberFormat(this.profileData.mobile, this.profileData.mobile, true) : null, valid: !!this.profileData.mobile },
                zipcode: { ...this.state.peronalInfoForm.zipcode, value: this.profileData.zipcode, valid: !!this.profileData.zipcode },
                state: { ...this.state.peronalInfoForm.state, value: this.profileData.state, valid: !!this.profileData.state },
                city: { ...this.state.peronalInfoForm.city, value: this.profileData.city, valid: !!this.profileData.city },
                address1: { ...this.state.peronalInfoForm.address1, value: this.profileData.address1, valid: !!this.profileData.address1 },
                address2: { ...this.state.peronalInfoForm.address2, value: this.profileData.address2, valid: true },
                contact: { ...this.state.peronalInfoForm.contact, value: this.profileData.contact ? mobileNumberFormat(this.profileData.contact, this.profileData.contact, true) : null, valid: true },
            },
            profileImage: { ...this.state.profileImage, imgSrc: this.profileData.url },
            peronalInfoFormValid: isValid,
            pageLoading: false,
            stateList: stateList,
            cityList: cityList,
            unverifiedemail: this.profileData.unverifiedemail,
            emailverified: this.profileData.emailverified,
            newEmail: { ...this.state.newEmail, value: this.profileData.unverifiedemail ? this.profileData.unverifiedemail : null },
            isemailchanged: this.profileData.unverifiedemail ? false : true,
            dontEdit: !!this.profileData.mobile,
            showAppleid: this.profileData.appleid,
            showFacebookid: this.profileData.facebookid,
            showGoogleid : this.profileData.googleid
        }, () => {
            this.checkPersonalInfoStateAndCity(this.state.peronalInfoForm.zipcode.value, this.state.peronalInfoForm.state.value, this.state.peronalInfoForm.city.value)
            if(this.state.peronalInfoForm.nickname.error == ''){
                const data = {
                    "data": {
                        "username": this.profileData.nickname,
                    }
                };
                axios.post(getBuyersUrl(bannedwords), JSON.stringify(data), getBuyerHeaders())
                    .then(response => {
                        this.setState({
                            ...this.state,

                            peronalInfoForm: {
                                ...this.state.peronalInfoForm,
                                nickname: {
                                    ...this.state.peronalInfoForm.nickname,
                                    error: !response.data.data.username.valid ? response.data.data.username.message : ''
                                }

                            },
                        })

                    })
                    .catch(error => {

                    });
            }
        });   
    }
    validateName = (value) => {
        const alphabeticPattern = /^[a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑÊêÂâÎîÔôÛûËëÏïÜüòÒàÀèÈìÌùÙçÇ`']*$/;
        if (/[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\\/;'’]/.test(value)) {
            return "Please only use alphanumeric characters"
        } 
        else if (value.length == 1) {
            return "Nickname should be minimum of 2 characters"
        } 
        else if (alphabeticPattern.test(value)) {
            return "";
        }
        else {
            return "Please enter a valid character";
        }
    };
    

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName = "peronalInfoForm") => {
        let controlError = '';

        if (event.target.name === 'mobile') {
            const temp = mobileNumberFormat(event.target.value, this.state.peronalInfoForm.mobile.value);
            event.target.value = temp ? temp : event.target.value;
        }

        if (event.target.name === 'contact') {
            const temp = mobileNumberFormat(event.target.value, this.state.peronalInfoForm.contact.value);
            event.target.value = temp ? temp : event.target.value;
            if (event.target.value) {
                const check = Validators.mobile();
                controlError = check(event.target.value);
            } else {
                controlError = ''
            }
        }

        if(event.target.name === 'city'){
            let cityData = event.target.value.replace(/[^a-zA-Z ]/g, "")
            event.target.value = cityData;
            this.checkPersonalInfoStateAndCity(this.state.peronalInfoForm.zipcode.value, this.state.peronalInfoForm.state.value, event.target.value);
            if(this.state.cityDropdownValue.length > 0 && !this.state.showCityDropdown){
                this.setState({
                    showCityDropdown: true
                })
            }
        }

        if(event.target.name === "state") {
            this.checkPersonalInfoStateAndCity(this.state.peronalInfoForm.zipcode.value, event.target.value, this.state.peronalInfoForm.city.value);
        }

        if(event.target.name === 'zipcode'){

            let data = event.target.value.replace(/[^0-9]/g, '').substring(0, 5);
            event.target.value = data;
        }

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        const validateName = (value) => {
            const alphabeticPattern = /^[a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑÊêÂâÎîÔôÛûËëÏïÜüòÒàÀèÈìÌùÙçÇ`']*$/;
            if (alphabeticPattern.test(value)) {
                return "";
            }
            else if (/[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\\/;'’]/.test(value)) {
                return "Please only use alphanumeric characters"
            } else {
                return "Please enter a valid character";
            }
        };
        
        if (event.target.name === "nickname") {
            const alphabeticPatternError = validateName(event.target.value)
            if (alphabeticPatternError) {
                controlError = alphabeticPatternError;
            }
            event.target.value  = event.target.value.replace(/\s+/g, '');
        }


        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                if(event.target.name == "nickname" && !controlError &&  this.profileData.nickname !== event.target.value){
                    this.setState({profileBtnDisable: true }, () => {
                    if (this.timeoutInterval) {
                        clearTimeout(this.timeoutInterval);
                    }
                    this.timeoutInterval = setTimeout(() =>  {
                        this.checkDetails(event);
                    }, 500);
                })
                }  
                /* check form validity */
                if (controlError)
                    this.setState({ peronalInfoFormValid: false }, () => { this.changeZipCode(event); });
                else {
                    let peronalInfoFormValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            peronalInfoFormValid = false;
                            break;
                        }
                    }
                    this.setState({ peronalInfoFormValid: peronalInfoFormValid }, () => { this.changeZipCode(event); });
                }
                this.saveDisable(event);
            });


    }

    checkDetails = (event) => {
        this.setState({
            apiLoading: true,
            profileBtnDisable: false
        });
        const key = event.target.name === 'newEmail' ? 'email' : event.target.name === 'newMobile' ? 'mobile' : event.target.name;
        let value = event.target.value
        if(event.target.name === 'newMobile'){
            value  =  value.replace(/\D/g, '');
        }
        const data = {
            data: {
                [key]: value
            }
        };
        authService.checkDetails(data).then(res => {
            this.setState({
                apiLoading: false
            })
            const result = res.data.data;
        
        
        }).catch(error => {
            this.setState({
                apiLoading: false
            })
          
            if( event.target.name === 'nickname'){
                if(error.ctbidserrorcode == "CBBY001" || error.ctbidserrorcode == "CBBY010" || error.ctbidserrorcode == "CBBY008" ||  error.ctbidserrorcode == "CBBY014" ||  error.ctbidserrorcode == "CBBY016" || error.ctbidserrorcode == "CBBY017" ){
                    this.setState({
                        ...this.state,
                        peronalInfoForm: {
                            ...this.state.peronalInfoForm,
                            nickname: {
                                ...this.state.peronalInfoForm['nickname'],
                                valid: Boolean( error.message),
                                error: error.message 
                            }
                        },
                        peronalInfoFormValid: !Boolean( error.message),
                    })

                } 
            }    
            else if( event.target.name === 'newEmail'){
                if(error.ctbidserrorcode == "CBBY001" ||  error.ctbidserrorcode == "CBBY010" || error.ctbidserrorcode == "CBBY008" || error.ctbidserrorcode == "CBBY014" || error.ctbidserrorcode == "CBBY017" ||  error.ctbidserrorcode == "CBBY016" || error.ctbidserrorcode == "CBBY018"){
                    this.setState({
                        ...this.state,
                        newEmail: {
                            ...this.state.newEmail,
                            error:  error.message
                        },
                    })

                } 
            }  
            else if (event.target.name === 'newMobile') {
                if (error.ctbidserrorcode == "CBBY001" || error.ctbidserrorcode == "CBBY008" || error.ctbidserrorcode == "CBBY009" || error.ctbidserrorcode == "CBBY010" || error.ctbidserrorcode == "CBBY014" || error.ctbidserrorcode == "CBBY016" || error.ctbidserrorcode == "CBBY019") {
                    this.setState({
                        ...this.state,
                        mobile: {
                            ...this.state.mobile,
                            newMobile: {
                                ...this.state.mobile['newMobile'],
                                error: error.message
                            },
                        },
                    })
                }
            }       
        });
    }

    saveDisable = () => {
        if (this.profileData.firstname != this.state.peronalInfoForm.firstName.value ||
            this.profileData.lastname != this.state.peronalInfoForm.lastName.value ||
            this.profileData.address1 != this.state.peronalInfoForm.address1.value ||
            this.profileData.address2 != this.state.peronalInfoForm.address2.value ||
            this.profileData.zipcode != this.state.peronalInfoForm.zipcode.value ||
            this.profileData.state != this.state.peronalInfoForm.state.value ||
            this.profileData.city != this.state.peronalInfoForm.city.value) {
            this.setState({
                isSaveDisable: false,
            })
        } else if (this.profileData.nickname != this.state.peronalInfoForm.nickname.value) {
            this.setState({
                isSaveDisable: false,
                nickNameChangedDate: true
            })
        } else {
            this.setState({
                isSaveDisable: true
            })
        }
    }

    checkPersonalInfoStateAndCity = (zipcode, state, city) => {
        this.setState({
            cityStateIsValid: false
        })
        const data = {
            "data": {
                "zipcode": zipcode,
                "state": state,
                "city": city
            }
        };
        if(state != "" && city != "" && zipcode != ""){
            CityAndStateService.checkCityState(data).then(response => {
                this.setState({
                    stateCityError: "",
                    cityStateIsValid: true,
                    showCityDropdown: false
                })
            }).catch(error => {
                if(error.status === 400 || error.status == "failed") {
                    this.setState({
                        stateCityError: this.errorMessage,
                        cityStateIsValid: false,
                        cityDropdownValue: error.error.data
                    })
                }
            }); 
        }   
    }

    /* event to trigger file input button internally */
    onClickFileInput = () => {
        document.getElementById('img-profile').click();
    };

    onUploadImage = (event) => {
        this.setState({
            profileImage: {
                ...this.state.profileImage,
                tempImg: URL.createObjectURL(event.target.files[0]),
                modal: true
            }
        });

        // reset input to upload same image
        event.target.value = '';
    };

    onCancelImage = () => {
        this.setState({
            profileImage: {
                ...this.state.profileImage,
                modal: false,
                tempImg: null
            }
        });
    };

    onSaveImage = (output) => {
        this.setState({
            profileImage: {
                ...this.state.profileImage,
                imgSrc: URL.createObjectURL(output.dest),
                modal: false
            }
        });

        // used to convert image to base 64
        let render = new FileReader();

        // trigger once image is loaded into FileReader
        render.onloadend = async () => {
            const data = {
                id: this.props.user.id,
                image: render.result.replace('data:', '').replace(/^.+,/, ''),
            };
            authService.profileUpdate({ data: data }).then(response => {
                store.dispatch({
                    type: 'SET_USER',
                    payload: {
                        profileImage: response.data['data'][0]['url'],
                        id: this.props.user.id
                    }
                });
                // TODO: success message handle
                setUser(this.props.user.id);
            }).catch(error => {
                this.setState({ profileFormLoading: false });
                // TODO: Error message handle
            });
        };

        render.readAsDataURL(output.dest);
    };

    changePrimaryNumber = (flag) => {
        if (flag === this.state.mobileNumberVerify) {
            this.setState({
                ...this.state,
                mobileNumberVerify: ''
            });
        } else {
            this.setState({
                ...this.state,
                mobileNumberVerify: flag
            });
        }

    }

    changeZipCode = (event) => {
        if (event.target.name === 'zipcode' && event.target.value.length === 5) {
            CityAndStateService.getZipCodeDeatils(event.target.value).then(
                response => {
                    const data = response.data.data;
                    if (data.length > 0) {
                        CityAndStateService.getCityList(data[0].state).then(
                            cityList => {
                                const temp = cityList.data.data;
                                this.setState({
                                    cityList: ArrayValueReorder(temp, 'city'),
                                    peronalInfoForm: {
                                        ...this.state.peronalInfoForm,
                                        state: {
                                            ...this.state.peronalInfoForm.state,
                                            value: data[0].state,
                                            valid: true,
                                            error: ''
                                        },
                                        // city: {
                                        //     ...this.state.peronalInfoForm.city,
                                        //     value: data[0].city,
                                        //     valid: true,
                                        //     error: ''
                                        // },
                                    }
                                }, () => {
                                    this.checkPersonalInfoStateAndCity(event.target.value, this.state.peronalInfoForm.state.value, this.state.peronalInfoForm.city.value)
                                    let peronalInfoFormValid = true;
                                    for (let control of Object.keys(this.state.peronalInfoForm)) {
                                        if (!this.state.peronalInfoForm[control].valid) {
                                            peronalInfoFormValid = false;
                                            break;
                                        }
                                    }
                                    this.setState({ peronalInfoFormValid: peronalInfoFormValid });
                                });
                            }
                        ).catch(error => error);
                    } else {
                        this.setState({
                            peronalInfoForm: {
                                ...this.state.peronalInfoForm,
                                state: {
                                    ...this.state.peronalInfoForm.state,
                                    value: '',
                                    valid: false,
                                },
                                // city: {
                                //     ...this.state.peronalInfoForm.city,
                                //     value: '',
                                //     valid: false,
                                // },
                            }
                        }, () => {
                            let peronalInfoFormValid = true;
                            for (let control of Object.keys(this.state.peronalInfoForm)) {
                                if (!this.state.peronalInfoForm[control].valid) {
                                    peronalInfoFormValid = false;
                                    break;
                                }
                            }
                            this.setState({ peronalInfoFormValid: peronalInfoFormValid });
                        });
                    }
                }
            ).catch(error => error);
        }

        if (event.target.name === 'state') {
            CityAndStateService.getCityList(event.target.value).then(
                cityList => {
                    this.setState({
                        cityList: ArrayValueReorder(cityList.data.data, 'city'),
                        peronalInfoForm: {
                            ...this.state.peronalInfoForm,
                            // city: {
                            //     ...this.state.peronalInfoForm.city,
                            //     value: '',
                            //     valid: false,
                            // },
                        }
                    }, () => {
                        let peronalInfoFormValid = true;
                        for (let control of Object.keys(this.state.peronalInfoForm)) {
                            if (!this.state.peronalInfoForm[control].valid) {
                                peronalInfoFormValid = false;
                                break;
                            }
                        }
                        this.setState({ peronalInfoFormValid: peronalInfoFormValid });
                    });
                }
            ).catch(error => error);
        }
    }

    updateProfile = () => {
        if (!this.state.dontEdit) {
            this.setState({
                loading: true
            })
            const data = {
                data: {
                    mobile: this.state.peronalInfoForm.mobile.value,
                }
            };
            MyAccountService.mobileNumberValidate(data)
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({
                        errorMsg: '',
                        loading: false
                    });
                    this.showMobileModal();
                }
            })
            .catch(error => {
                this.setState({
                    errorMsg: error.message,
                    loading: false
                });
            });
            
            this.setState({
                mobile: {
                    ...this.state.mobile,
                    newMobile: {
                        ...this.state.mobile.newMobile,
                        value: this.state.peronalInfoForm.mobile.value,
                        error: '',
                        valid: true
                    },
                    valid: true
                }
            });
        } else {
            this.setState({
                loading: true,
                prfileUpdate: {
                    ...this.state.prfileUpdate,
                    show: false
                }
            }, () => {
                const data = {
                    id: this.props.user.id,
                    firstname: this.state.peronalInfoForm.firstName.value,
                    lastname: this.state.peronalInfoForm.lastName.value,
                    nickname: this.state.peronalInfoForm.nickname.value,
                    email: this.state.peronalInfoForm.email.value,
                    mobile: this.state.peronalInfoForm.mobile.value ? this.state.peronalInfoForm.mobile.value : undefined,
                    zipcode: this.state.peronalInfoForm.zipcode.value,
                    state: this.state.peronalInfoForm.state.value,
                    city: this.state.peronalInfoForm.city.value,
                    address1: this.state.peronalInfoForm.address1.value,
                    address2: this.state.peronalInfoForm.address2.value,
                    contact: this.state.peronalInfoForm.contact.value ? this.state.peronalInfoForm.contact.value : null,
                    nomarketingemail: this.state.nomarketingemail,
                    country: 'USA',
                    addresstype: 'Primary',
                    addressValidated: this.state.selectedAddress == 'recommended' ? false : true,
                    modifieddatenickname: this.state.nickNameChangedDate ? moment().utc().format('YYYY-MM-DD HH:mm:ss') : null
                }
                if(!this.props.user.profilecompleted) {
                    data['shipping'] = true
                }
                // if (this.state.peronalInfoForm.contact.value) {
                //     data['contact'] = this.state.peronalInfoForm.contact.value;
                // }
                authService.profileUpdate({ data: data }).then(response => {
                    // TODO: success message handle
                    let data = response.data.data
                    this.profileData = {
                        ...this.profileData,
                        firstname: this.state.peronalInfoForm.firstName.value,
                        lastname: this.state.peronalInfoForm.lastName.value,
                        nickname: this.state.peronalInfoForm.nickname.value,
                        zipcode: this.state.peronalInfoForm.zipcode.value,
                        state: this.state.peronalInfoForm.state.value,
                        city: this.state.peronalInfoForm.city.value,
                        address1: this.state.peronalInfoForm.address1.value,
                        address2: this.state.peronalInfoForm.address2.value,
                    }
            
                    if(data.recommend){
                        this.setState({
                            loading: false,
                            showProfileAddressValidateModal: true,
                            profileRecommendedAddress: {
                                ...this.state.profileRecommendedAddress,
                                address1: { value: data?.address?.address1 ? data.address.address1 : '' },
                                address2: { value: data?.address?.address2 ? data.address.address2 : '' },
                                state: { value: data?.address?.state ? data.address.state : '' },
                                city: { value: data?.address?.city ? data.address.city : '' },
                                zipcode: { value: data?.address?.zipcode ? data.address.zipcode : '' }
                            }
                        }, () => {
                            this.saveDisable()
                        });
                    } else {
                        setUser(this.props.user.id).then((userData) => {
                            this.setState({
                                loading: false,
                                selectedAddress: "entered",
                                showAddressError: false
                            }, () => {
                                this.saveDisable()
                            })
                            this.toasterMessage.current.showMessage({ type: 'success', message: 'Your profile has been updated successfully' });
                            this.dataTable.current.getTableData();
                            pmAutoNavigateToNextScreen(this.props, this.previousProfile, userData, "profilecompleted");
                        });
                    }                    
                    // if(this.props.location?.state?.name =="bidscreen") {
                    //     setTimeout(() => {
                    //         this.props.history.push(this.props.location.state.previouspath);
                    //     }, 1000);
                    // }
                }).catch(error => {
                    // TODO: Error message handle   
                    this.setState({
                        loading: false,
                        profileFormLoading: false
                    });
                    this.toasterMessage.current.showMessage({ type: 'danger', message: error.message });    
                });
            });
        }
    }

    showEmailModal = () => {
        this.setState({
            emailModal: true
        });
    };

    hideEmailModal = (getData = true) => {
        this.setState({
            showScmRemoveModel: true,
            emailModal: false,
            newEmail: {
                ...this.state.newEmail,
                value: this.profileData.unverifiedemail ? this.profileData.unverifiedemail : '',
                error: ''
            },
            isemailchanged: false
        }, () => {
            if (getData) {
                this.getProfileData();
            }
        });
    };

    onEmailChange = (event) => {
        let inputError = '';

        /* check validation */
        for (let validator of this.state.newEmail.validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }
        if (event.target.value === this.state.newEmail.email){
            inputError = 'Should not use same email';
        }

        if (!inputError) {
            this.setState({profileBtnDisable: true }, () => {
            if (this.timeoutInterval) {
                clearTimeout(this.timeoutInterval);
            }
            this.timeoutInterval = setTimeout(() => {
                this.checkDetails(event);
            }, 500);
        })
        }

        this.setState({
            newEmail: {
                ...this.state.newEmail,
                value: event.target.value,
                error: inputError
            }
        });
    };

    /* request to re-send verify email for new email */
    verifyNewEmail = () => {
        this.setState({ verifyLoading: true })
        MyAccountService.verifyNewEmail()
            .then(response => {
                // TODO: success message handle
            })
            .catch(error => {
                // TODO: Error message handle
            })
            .finally(() => {
                this.setState({ verifyLoading: false, emailModal: false }, () => this.getProfileData());
            });
    }

    saveNewEmail = () => {
        if (this.state.unverifiedemail === this.state.newEmail.value && !this.state.isemailchanged) {
            this.setState({ isemailchanged: true });
        }
        else {
            if (!this.state.newEmail.error) {
                const data = {
                    data: {
                        newemail: this.state.newEmail.value
                    }
                };

                this.setState({ emailLoading: true });
                MyAccountService.saveNewEmail(data)
                    .then(response => {

                        // TODO: success message handle
                        this.toasterMessageForNewEmail.current.showMessage({ type: 'success', message:  !this.state.showScmRemoveModel ?'An email has been sent to verify the new email address and create a new password' : 'Saved' });
                        setTimeout(() => {
                            this.setState({
                                // peronalInfoForm: {
                                //     ...this.state.peronalInfoForm,
                                //     email: {
                                //         ...this.state.peronalInfoForm.email,
                                //         value: this.state.newEmail.value
                                //     }
                                // },
                                showScmRemoveModel: true,
                                emailLoading: false,
                                emailModal: false,
                                unverifiedemail: this.state.newEmail.value,
                                emailverified: 0
                            }, () => this.getProfileData());
                            this.profileData['unverifiedemail'] = this.state.newEmail.value;
                            this.profileData['emailverified'] = 0;
                        }, 1000);
                    })
                    .catch(error => {
                        if(error.ctbidserrorcode == 'CBBY017'){
                            this.setState({
                                showScmRemoveModel: false,
                                scmMessage: error.message,
                                emailLoading: false,
                            })
                        }
                        else{
                        this.setState({ emailLoading: false });
                        // TODO: Error message handle
                        this.toasterMessageForNewEmail.current.showMessage({ type: 'danger', message: error.message });
                        }
                    });
            }
        }
    }

    showMobileModal = () => {
        this.setState({
            mobileModal: true
        });
    }

    hideMobileModal = () => {
        this.setState({
            mobileModal: false,
            isOtpSent: false,
            mobile: {
                ...this.state.mobile,
                newMobile: {
                    ...this.state.mobile.newMobile,
                    value: '',
                    error: '',
                    valid: false
                },
                otp: {
                    ...this.state.mobile.otp,
                    value: '',
                    error: '',
                    valid: false
                },
                valid: false

            },
            profileStatus: { show: false, type: '', message: '' }
        });
    }

    /* new mobile number changed */
    onMobileChange = (event) => {
        let inputError = '';
        this.toasterMessageForNewMobile.current.hideMessage(0);
        if (event.target.name === 'newMobile') {
            const eventValue = event.target.value ? mobileNumberFormat(event.target.value, this.state.mobile.newMobile.value) : '';
            event.target.value = eventValue ? eventValue : event.target.value;
        }
        /* check validation */
        for (let validator of this.state.mobile[event.target.name].validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }

        if (event.target.value === this.state.peronalInfoForm.mobile.value)
            inputError = 'Should not use same phone number';

        this.setState({
            mobile: {
                ...this.state.mobile,
                [event.target.name]: {
                    ...this.state.mobile[event.target.name],
                    value: event.target.value,
                    error: inputError,
                    valid: Boolean(!inputError)
                }
            },
            profileStatus: { show: false, type: null, message: null },
        }, () => {
            let valid = false;
            if (this.state.isOtpSent)
                valid = this.state.mobile.newMobile.valid && this.state.mobile.otp.value;
            else
                valid = this.state.mobile.newMobile.valid;
            this.setState({
                mobile: {
                    ...this.state.mobile,
                    valid: valid
                }
            });

            if (!inputError && event.target.name !== "otp") {
                this.setState({  profileBtnDisable: true }, () => {

                if (this.timeoutInterval) {
                    clearTimeout(this.timeoutInterval);
                }
                this.timeoutInterval = setTimeout(() => {
                    this.checkDetails(event);
                }, 200);
            })
            }
        });
    };

    /* otp generated when mobile number changed */
    generateOtp = (flag) => {
        this.setState({
            loaderHandle: flag,
            getOtpType: flag,
            mobileLoading: true,
            profileStatus: { show: false, type: '', message: '' }
        }, () => {
            const data = {
                data: {
                    newmobile: this.state.mobile.newMobile.value,
                    otpvia: flag
                }
            };
            this.toasterMessageForNewMobile.current.hideMessage(0);
            MyAccountService.changeMobile(data)
                .then(response => {
                    if (response.data.status === 'success') {
                        this.setState({
                            isOtpSent: true,
                            mobileLoading: false,
                            mobile: {
                                ...this.state.mobile,
                                valid: false
                            },
                            loaderHandle: null
                        });
                    }
                })
                .catch(error => {
                    this.toasterMessageForNewMobile.current.showMessage({ type: 'danger', message: error.message || 'Failed to update mobile' }, 3000, true);
                    this.setState({
                        isOtpSent: false,
                        mobileLoading: false,
                        profileStatus: { show: true, type: 'danger', message: error.message || 'Failed to update mobile' },
                    });
                });
        });
    }

    /* called to resend otp  */
    resendOtp = () => {
        this.toasterMessageForNewMobile.current.hideMessage(0);
        this.setState({ profileStatus: { show: false, type: '', nmessage: '' }, resendOtp: true });
        const postData = {
            data: {
                otpvia: this.state.getOtpType
            }
        };
        MyAccountService.resendOtp(postData)
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({ isOtpSent: true, resendOtp: false });
                }
            })
            .catch(error => {
                this.toasterMessageForNewMobile.current.showMessage({ type: 'danger', message: error.message || 'Failed to update mobile' }, 3000, true);
                this.setState({
                    isOtpSent: false,
                    resendOtp: false,
                    profileStatus: { show: true, type: 'danger', message: error.message || 'Failed to update mobile' }
                });
            });
    }

    /* submit otp to verify mobile number  */
    submitOtp = () => {
        this.toasterMessageForNewMobile.current.hideMessage(0);
        this.setState({ mobileLoading: true, profileStatus: { show: false, type: '', message: '' } });
        MyAccountService.verifyMobile(this.state.mobile.otp.value)
            .then(response => {
                if (response.data.status === 'success') {
                    this.toasterMessageForNewMobile.current.showMessage({ type: 'success', message: response.data['message'] });
                    this.setState({
                        profileStatus: { show: true, type: 'success', message: response.data['message'] },
                        mobileLoading: false
                    }, () => {
                        const dontEdit = JSON.parse(JSON.stringify(this.state.dontEdit));
                        setTimeout(() => {
                            this.hideMobileModal();
                            this.setState({
                                mobileModal: false,
                                profileStatus: { show: false, type: '', message: '' },
                                dontEdit: true
                            }, () => {
                                if (!dontEdit) {
                                    this.updateProfile();
                                } else {
                                    this.getProfileData();
                                }
                            });
                        }, 3000)
                    });
                }
            })
            .catch(error => {
                this.toasterMessageForNewMobile.current.showMessage({ type: 'danger', message: error.message || 'Failed to update mobile' }, 3000, true);
                this.setState({
                    mobileLoading: false,
                    profileStatus: { show: true, type: 'danger', message: error.message || 'Failed to update mobile' }
                });
            });
    }

    navigate = (flag) => {
        this.props.history.push(flag);
    }

    windowResizeHandle = () => {
        ToggleSideBar();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResizeHandle);
        removeSideBar();
    }
    // changeCheckboxvalue(event) {
    //     let value = event.target.checked
    //     if (value === true)
    //         this.setState({
    //             nomarketingemail: 1
    //         })
    //     else {
    //         this.setState({
    //             nomarketingemail: 0
    //         })
    //     }

    // }

    customRadioButton = (values) => {
        return (
            <div className="default-radio">
                <input type="radio" className="radio-btn" aria-label='select default shipping address' name="defaultShippingAddress" id={`inline-${values.addressid}`} checked={values['shipping']} onChange={()=>{this.updateShippingAddress(values.addressid, true)}} />
            </div>
        );
    };

    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div style={{ padding: "1% 2%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex" style={{ justifyContent: "space-evenly"}}>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">City</div>
                            <div>{row['city']}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">State</div>
                            <div>{row['state']}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">zip code</div>
                            <div>{row['zipcode']}</div>
                        </div>
                        {/* <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Latitude</div>
                            <div>{this.customLatitude(row['latitude'])}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Longitude</div>
                            <div>{this.customLongitude(row['longitude'])}</div>
                        </div> */}
                    </div>
                    : ''}
            </div>
        );
    }

    customLatitude = (values) => {
        if (!values) {
            return "- - -";
        } else {
            return values;
        }
    }

    customLongitude = (values) => {
        if (!values) {
            return "- - -";
        } else {
            return values;
        }
    }

    shippingValidation = (event) => {
        let controlError = '';

        if(event.target.name === 'zipcode'){
            let zipcode = event.target.value.replace(/[^0-9]/g, '');
            event.target.value = zipcode;
        }

        if(event.target.name === 'city'){
            let cityData = event.target.value.replace(/[^a-zA-Z ]/g, "")
            event.target.value = cityData;
            this.checkShippingStateAndCity(this.state.shippingForm.zipcode.value, this.state.shippingForm.state.value, event.target.value);
            if(this.state.shippingCityDropdownValue.length > 0 && !this.state.shippingShowCityDropdown){
                this.setState({
                    shippingShowCityDropdown: true
                })
            }
        }

        if(event.target.name === 'state') {
            this.checkShippingStateAndCity(this.state.shippingForm.zipcode.value, event.target.value, this.state.shippingForm.city.value);
        }

        /* checks all the validators for the control */
        for (let validator of this.state.shippingForm[event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        this.setState({
            shippingForm: {
                ...this.state.shippingForm,
                [event.target.name]: {
                    ...this.state.shippingForm[event.target.name],
                    value: event.target.value, 
                    error: controlError,
                    valid: !Boolean(controlError)
                }
            }
        }, () => {
            this.checkShippingFormValidity(controlError, event)
        })
    }

    checkShippingStateAndCity = (zipcode, state, city) => {
        this.setState({
            shippingCityStateIsValid: false
        })
        const data = {
            "data": {
                "zipcode": zipcode,
                "state": state,
                "city": city
            }
        };
        if(state != "" && city != "" && zipcode != "") {
            CityAndStateService.checkCityState(data).then(response => {
                this.setState({
                    shippingStateCityError: "",
                    shippingCityStateIsValid: true,
                    shippingShowCityDropdown: false
                })
            }).catch(error => {
                if(error.status === 400 || error.status == "failed") {
                    this.setState({
                        shippingStateCityError: this.errorMessage,
                        shippingCityStateIsValid: false,
                        shippingCityDropdownValue: error.error.data
                    })
                }
            });
        }    
    }

    shippingCheckboxValidation = (value) => {
        let controlError = '';
        /* checks all the validators for the control */
        for (let validator of this.state.shippingForm['addresstype'].validators) {
            controlError = validator(value);
            if (controlError) break;
        }

        this.setState({
            shippingForm: {
                ...this.state.shippingForm,
                "addresstype": {
                    ...this.state.shippingForm.addresstype,
                    value: value,
                    error: controlError,
                    valid: !Boolean(controlError)
                }
            }
        }, () => {
            this.checkShippingFormValidity(controlError)
        })
    }

    checkShippingFormValidity = (controlError, event) => {
        if (controlError)
            this.setState({ shippingFormValid: false }, () => { this.onZipCodeChange(event); });
        else {
            let shippingFormValid = true;
            for (let control of Object.keys(this.state.shippingForm)) {
                if (!this.state.shippingForm[control].valid) {
                    shippingFormValid = false;
                    break;
                }
            }
            this.setState({ shippingFormValid: shippingFormValid }, () => { this.onZipCodeChange(event); });
        }
    }

    showShippingModal = () => {
        this.setShippingForm(null, true)
    }

    hideShippingModal = () => {
        this.setShippingForm(null, false);
        this.setState({
            shippingStateCityError: '',
            shippingShowCityDropdown: false,
            showShippingAddressError: false
        })
    }

    saveShippingAddress = () => {
        const data = {
            addresstype: this.state.shippingForm.addresstype.value,
            addressid: this.state.shippingForm.addressid.value,
            address1: this.state.shippingForm.address1.value,
            address2: this.state.shippingForm.address2.value,
            city: this.state.shippingForm.city.value,
            state: this.state.shippingForm.state.value,
            zipcode: this.state.shippingForm.zipcode.value,
            country: 'USA',
            // shipping: this.state.shippingForm.addresstype.value == "Shipping" ? true : false,
            // billing: this.state.shippingForm.addresstype.value == "Billing" ? true : false,
            latitude: this.state.shippingForm.latitude.value,
            longitude: this.state.shippingForm.longitude.value,
            // addressisactive: this.state.shippingForm.addressisactive.value
            addressValidated: this.state.shippingSelectedAddress == 'recommended' ? false : true
        }
        
        if(this.isEditShipping) {
            PersonalInfoService.shippingAddressUpdate({ data: data }).then(response => {
                this.setState({
                    shippingModal: false,
                })
                let data = response.data.data
                if(data?.recommend){
                    this.setState({
                        shippingModal: false,
                        showShippingAddressValidateModal: true,
                        shippingRecommendedAddress: {
                            ...this.state.shippingRecommendedAddress,
                            address1: { value: data?.address?.address1 ? data.address.address1 : '' },
                            address2: { value: data?.address?.address2 ? data.address.address2 : '' },
                            state: { value: data?.address?.state ? data.address.state : '' },
                            city: { value: data?.address?.city ? data.address.city : '' },
                            zipcode: { value: data?.address?.zipcode ? data.address.zipcode : '' }
                        }
                    }, () => {
                        this.getProfileData()
                    });
                } else {
                    this.setState({
                        shippingSelectedAddress: "entered",
                        shippingModal: true,
                        showShippingAddressError: false
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                shippingModal: false
                            })
                        }, 4000)
                    })
                    this.shippingMessage.current?.showMessage({ type: 'success', message: 'Your address has saved successfully' });
                    this.dataTable.current.getTableData();
                } 
            }).catch(error => {
                if(error.status === 400 || error.status == "400") {
                    this.setState({
                        showShippingAddressError: true
                    });
                } else {
                    this.shippingMessage.current?.showMessage({ type: 'danger', message: error.message });
                }  
            });
        } else {
            PersonalInfoService.shippingAddressCreate({ data: data }).then(response => {
                this.setState({
                    shippingModal: false,
                })
                let data = response.data.data
                if(data?.recommend){
                    this.setState({
                        shippingModal: false,
                        showShippingAddressValidateModal: true,
                        shippingRecommendedAddress: {
                            ...this.state.shippingRecommendedAddress,
                            address1: { value: data?.address?.address1 ? data.address.address1 : '' },
                            address2: { value: data?.address?.address2 ? data.address.address2 : '' },
                            state: { value: data?.address?.state ? data.address.state : '' },
                            city: { value: data?.address?.city ? data.address.city : '' },
                            zipcode: { value: data?.address?.zipcode ? data.address.zipcode : '' }
                        }
                    });
                } else {
                    this.setState({
                        shippingSelectedAddress: "entered",
                        shippingModal: true,
                        showShippingAddressError: false
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                shippingModal: false
                            })
                        }, 4000)
                    })
                    this.shippingMessage.current?.showMessage({ type: 'success', message: 'Your address has saved successfully' });
                    this.dataTable.current.getTableData();
                }
            }).catch(error => {
                if(error.status === 400 || error.status == "400") {
                    this.setState({
                        showShippingAddressError: true
                    });
                } else {
                    this.shippingMessage.current?.showMessage({ type: 'danger', message: error.message });
                }  
            });
        }
    }

    setShippingForm = (data, openShippingModal = false) => {
        this.setState({
            shippingForm: this.getShippingForm(data),
            shippingModal: openShippingModal ? true : false
        }, () => {
            this.checkShippingFormValidity()
            this.checkShippingStateAndCity(this.state.shippingForm.zipcode.value, this.state.shippingForm.state.value, this.state.shippingForm.city.value)
        })
        this.isEditShipping = data != null ? true : false
    }

    getShippingForm = (data) => {
        return {
            address1: { value: data?.address1 ? data.address1 : '', error: '', validators: [Validators.required(), Validators.maxLength(80)], valid: data?.address1 ? true : false },
            address2: { value: data?.address2 ? data.address2 : '', error: '', validators: [Validators.maxLength(80)], valid: true },
            city: { value: data?.city ? data.city : '', error: '', validators: [Validators.required(), Validators.maxLength(45)], valid: data?.city ? true : false },
            state: { value: data?.state ? data.state : '', error: '', validators: [Validators.required()], valid: data?.state ? true : false },
            zipcode: { value: data?.zipcode ? data.zipcode : '', error: '', validators: [Validators.equalToLength(5)], valid: data?.zipcode ? true : false },
            country: { value: data?.country ? data.country : '', error: '', validators: [], valid: true },
            addresstype: { value: data?.addresstype ? data.addresstype : "Shipping", error: '', validators: [], valid: true },
            addressid: { value: data?.addressid ? data.addressid : '', error: '', validators: [], valid: true },
            shipping: { value: data?.shipping ? data.shipping : false, error: '', validators: [], valid: true },
            billing: { value: data?.billing ? data.billing : false, error: '', validators: [], valid: true},
            latitude: { value: data?.latitude ? data.latitude : null, error: '', validators: [], valid: true },
            longitude: { value: data?.longitude ? data.longitude : null, error: '', validators: [], valid: true },
            addressisactive: { value: data?.addressisactive ? data.addressisactive : 0, error: '', validators: [], valid: true }
        }
    }

    updateShippingAddress = (id, value) => {
        const data = {
            addressid: id,
            shipping: value
        }
        PersonalInfoService.shippingAddressUpdate({ data: data }).then(response => {
            if(response.data.status.toLowerCase() == "success") {
                this.dataTable.current.getTableData();
            }
        }).catch(error => {
            //error handle
        });
    }

    deleteShippingAddress = (postData) => {
        const data = {
            addressid: postData.addressid
        }
        axios.delete(getBuyersUrl(`${shippingAddressDelete}`), getBuyerHeaders(true, 'json', {"data": data})).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                this.dataTable.current.getTableData();
            }
        }).catch(error => {
            if(error.response.status == 400 || error.response.data.status == "failed") {
                this.setState({
                    showShippingErrorModal: true,
                    showShippingErrorMessage: error.response.data.message
                })
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            showShippingErrorModal: false
        })
    }

    onZipCodeChange = (event) => {
        if (event?.target.name === 'zipcode' && event?.target.value.length === 5) {
            CityAndStateService.getZipCodeDeatils(event.target.value).then(
                response => {
                    const data = response.data.data;
                    if (data.length > 0) {
                        CityAndStateService.getCityList(data[0].state).then(
                            cityList => {
                                const temp = cityList.data.data;
                                this.setState({
                                    cityList: ArrayValueReorder(temp, 'city'),
                                    shippingForm: {
                                        ...this.state.shippingForm,
                                        state: {
                                            ...this.state.shippingForm.state,
                                            value: data[0].state,
                                            valid: true,
                                            error: ''
                                        }
                                    }
                                }, () => {
                                    this.checkShippingStateAndCity(event.target.value, this.state.shippingForm.state.value, this.state.shippingForm.city.value)
                                    let shippingFormValid = true;
                                    for (let control of Object.keys(this.state.shippingForm)) {
                                        if (!this.state.shippingForm[control].valid) {
                                            shippingFormValid = false;
                                            break;
                                        }
                                    }
                                    this.setState({ shippingFormValid: shippingFormValid });
                                });
                            }
                        ).catch(error => error);
                    } else {
                        this.setState({
                            shippingForm: {
                                ...this.state.shippingForm,
                                state: {
                                    ...this.state.shippingForm.state,
                                    value: '',
                                    valid: false,
                                }
                            }
                        }, () => {
                            let shippingFormValid = true;
                            for (let control of Object.keys(this.state.shippingForm)) {
                                if (!this.state.shippingForm[control].valid) {
                                    shippingFormValid = false;
                                    break;
                                }
                            }
                            this.setState({ shippingFormValid: shippingFormValid });
                        });
                    }
                }
            ).catch(error => error);
        }

        if (event?.target.name === 'state') {
            CityAndStateService.getCityList(event.target.value).then(
                cityList => {
                    this.setState({
                        cityList: ArrayValueReorder(cityList.data.data, 'city'),
                        shippingForm: {
                            ...this.state.shippingForm,
                        }
                    }, () => {
                        let shippingFormValid = true;
                        for (let control of Object.keys(this.state.shippingForm)) {
                            if (!this.state.shippingForm[control].valid) {
                                shippingFormValid = false;
                                break;
                            }
                        }
                        this.setState({ shippingFormValid: shippingFormValid });
                    });
                }
            ).catch(error => error);
        }
    };

    setCityValue = (city) => {
        this.setState({
            peronalInfoForm: {
                ...this.state.peronalInfoForm,
                city: {
                    ...this.state.peronalInfoForm.city,
                    value: city,
                    error: '',
                    valid: true
                }
            },
            showCityDropdown: false,
        }, ()=>{
            let controlError = '';
            for (let validator of this.state.peronalInfoForm.city.validators) {
                controlError = validator(city);
                if (controlError) break;
            }
            if (controlError)
                this.setState({ peronalInfoFormValid: false }, () => {
                    this.checkPersonalInfoStateAndCity(this.state.peronalInfoForm.zipcode.value, this.state.peronalInfoForm.state.value, city)
                });
            else {
                let peronalInfoFormValid = true;
                for (let control of Object.keys(this.state.peronalInfoForm)) {
                    if (!this.state.peronalInfoForm[control].valid) {
                        peronalInfoFormValid = false;
                        break;
                    }
                }
                this.setState({ peronalInfoFormValid: peronalInfoFormValid }, () => {
                    this.checkPersonalInfoStateAndCity(this.state.peronalInfoForm.zipcode.value, this.state.peronalInfoForm.state.value, city)
                });
            }
        })
    }

    setShippingCityValue = (city) => {
        this.setState({
            shippingForm: {
                ...this.state.shippingForm,
                city: {
                    ...this.state.shippingForm.city,
                    value: city,
                    error: '',
                    valid: true
                }
            },
            shippingShowCityDropdown: false,
        }, ()=>{
            let controlError = '';
            if (controlError)
                this.setState({ shippingFormValid: false }, () => {
                    this.checkShippingStateAndCity(this.state.shippingForm.zipcode.value, this.state.shippingForm.state.value, city)
                });
            else {
                let shippingFormValid = true;
                for (let control of Object.keys(this.state.shippingForm)) {
                    if (!this.state.shippingForm[control].valid) {
                        shippingFormValid = false;
                        break;
                    }
                }
                this.setState({ shippingFormValid: shippingFormValid }, () => {
                    this.checkShippingStateAndCity(this.state.shippingForm.zipcode.value, this.state.shippingForm.state.value, city)
                });
            }
        })
    }

    addressCheckboxValidation = (value) => {
        this.setState({
            selectedAddress: value
        })
    }

    shippingAddressCheckboxValidation = (value) => {
        this.setState({
            shippingSelectedAddress: value
        })
    }

    saveValidatedAddress = () => {
        if (this.state.selectedAddress == 'recommended') {
            this.setState({
                peronalInfoForm: {
                    ...this.state.peronalInfoForm,
                    address1: {...this.state.peronalInfoForm.address1, value: this.state.profileRecommendedAddress?.address1?.value},
                    address2: {...this.state.peronalInfoForm.address2, value: this.state.profileRecommendedAddress?.address2?.value},
                    state: {...this.state.peronalInfoForm.state, value: this.state.profileRecommendedAddress?.state?.value},
                    city: {...this.state.peronalInfoForm.city, value: this.state.profileRecommendedAddress?.city?.value},
                    zipcode: {...this.state.peronalInfoForm.zipcode, value: this.state.profileRecommendedAddress?.zipcode?.value}
                },
                showProfileAddressValidateModal: false,
                showAddressError: false
            }, () => {
                this.updateProfile()
            })
        } else {
            this.setState({
                showProfileAddressValidateModal: false,
                selectedAddress: "entered",
                showAddressError: true
            })
        }
    }

    cancelValidateAddress = () => {
        this.setState({ 
            showProfileAddressValidateModal: false, 
            selectedAddress: "entered",
            showAddressError: true 
        }) 
    }

    saveShippingValidatedAddress = () => {
        if (this.state.shippingSelectedAddress == 'recommended') {
            this.setState({
                shippingForm: {
                    ...this.state.shippingForm,
                    address1: {...this.state.shippingForm.address1, value: this.state.shippingRecommendedAddress?.address1?.value},
                    address2: {...this.state.shippingForm.address2, value: this.state.shippingRecommendedAddress?.address2?.value},
                    state: {...this.state.shippingForm.state, value: this.state.shippingRecommendedAddress?.state?.value},
                    city: {...this.state.shippingForm.city, value: this.state.shippingRecommendedAddress?.city?.value},
                    zipcode: {...this.state.shippingForm.zipcode, value: this.state.shippingRecommendedAddress?.zipcode?.value}
                },
                showShippingAddressValidateModal: false,
                showShippingAddressError: false
            }, () => {
                this.saveShippingAddress()
            })
        } else {
            this.setState({
                showShippingAddressValidateModal: false,
                shippingSelectedAddress: "entered",
                shippingModal: true,
                showShippingAddressError: true
            })
        }
    }

    cancelShippingValidateAddress = () => {
        this.setState({
            showShippingAddressValidateModal: false,
            shippingSelectedAddress: "entered",
            showShippingAddressError: true,
            shippingModal: true
        })
    }

    render() {
        return (
            <div className="personal-info">
                {
                    this.state.pageLoading ?
                        <Loader /> :
                        <div className="main-content flex-grow-1">
                            {/* <HeaderHOC {...this.props}/> */}
                            <div className="profile-image-main mb-3">
                                <div className=' text-bold'>
                                    <span style={{ color: "#00263E", marginLeft:  window.innerWidth > 990 && "25px", fontSize: "larger" }}>Please Tell Us About Yourself And Add Your Image, </span>
                                    <span style={{ color: "#A50050", fontSize: "larger" }}>{this.state.peronalInfoForm.firstName.value}</span>
                                </div>
                                <div className="d-flex justify-content-start align-items-center profile-background profile-image mt-4 gap-3">
                                    <div className="d-flex flex-row align-items-center justify-content-center profile-rounded">
                                        {
                                            this.state.profileImage.imgSrc ?
                                                <img src={this.state.profileImage.imgSrc} alt="profile-image" height="95" width="135" /> :
                                                <img src={userImage} alt="default-image" />
                                        }
                                    </div>
                                    <Form.Control id="img-profile" aria-label='profile-image' type="file" onChange={this.onUploadImage} accept={IMAGE_TYPES} hidden />
                                    <span className="add-text text-bold " style={{ cursor: 'pointer' }} onClick={this.onClickFileInput}>
                                        {this.state.profileImage.imgSrc ? 'Change image' : 'Add image'}
                                    </span>
                                </div>
                            </div>
                            <Form className="change-password-card">
                                <div className="row-handle d-lg-flex">
                                    <div className="col-handle-2">
                                        <Form.Label htmlFor="firstname" className="required fs-16 text-bold">First Name</Form.Label>
                                        <div className="float-control lg">
                                            {
                                                this.state.peronalInfoForm.firstName.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.firstName.error}</small> : null
                                            }
                                            <Form.Control size="lg" type="text" id="firstname"  className="fs-16" name="firstName" placeholder=" " value={this.state.peronalInfoForm.firstName.value} onChange={this.onInputValidation} readOnly />
                                        </div>
                                    </div>
                                    <div className="col-handle-2">
                                        <Form.Label htmlFor="lastname" className="required fs-16 text-bold">Last Name</Form.Label>
                                        <div className="float-control lg">
                                            {
                                                this.state.peronalInfoForm.lastName.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.lastName.error}</small> : null
                                            }
                                            <Form.Control size="lg" type="text" id="lastname"  className="fs-16" name="lastName" placeholder=" " value={this.state.peronalInfoForm.lastName.value} onChange={this.onInputValidation} readOnly />
                                        </div>
                                    </div>
                                </div>
                                <div className="row-handle d-lg-flex" style={{marginBottom: '5px'}}>
                                    {   
                                        <small className="text-berry name-disable">Need to update your First or Last Name? Please call CTBids HELP at 844-424-3435.</small>
                                    }
                                </div>
                                <div className="row-handle d-lg-flex">
                                    <div className="col-handle-2">
                                        <Form.Label htmlFor="username fs-16" className="required text-bold">User Name</Form.Label>
                                        <div className="float-control lg" style={{marginBottom: window.innerWidth > 990 &&'25px'}}>
                                            {
                                                this.state.peronalInfoForm.nickname.error ? <small style={{marginTop: '35px', position: 'absolute', top: '15px', lineHeight: '1'}} className="text-danger">{this.state.peronalInfoForm.nickname.error}</small> : null
                                            }
                                            <Form.Control size="lg" type="text" id="username" className="fs-16" name="nickname" placeholder="User Name" value={this.state.peronalInfoForm.nickname.value} onChange={this.onInputValidation} />
                                        </div>
                                    </div>
                                    <div className="col-handle-2">
                                       
                                        <Form.Label htmlFor="email" className="required fs-16 text-bold">Email</Form.Label>
                                        <div className="float-control lg">
                                            {
                                                this.state.peronalInfoForm.email.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.email.error}</small> : null
                                            }
                                            <Form.Control size="lg" type="text" id="email" className="fs-16" name="email" placeholder=" " value={this.state.peronalInfoForm.email.value} onChange={this.onInputValidation} readOnly />
                                        </div>
                                        <div className="d-flex flex-row justify-content-start change-email-container">
                                            <div className="change-email-link change-email clickable" onClick={this.showEmailModal}>Click here to change email</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row-handle d-lg-flex">
                                    <div className="col-handle-2" style={{marginTop: window.innerWidth < 990 && '30px'}}>
                                     
                                        <Form.Label htmlFor="mobile"  className="required fs-16 text-bold">Phone Number</Form.Label>
                                        <div className="float-control lg">
                                            {
                                                !this.state.dontEdit && this.state.peronalInfoForm.mobile.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.mobile.error}</small> : null
                                            }
                                            <Form.Control size="lg" type="text" className="fs-16" id="mobile" name="mobile" placeholder=" " value={this.state.peronalInfoForm.mobile.value} readOnly={this.state.dontEdit} onChange={this.onInputValidation} />
                                        </div>
                                        {/* <Form.Check type="checkbox" className="text-muted" label="Use this number for verification" checked={this.state.mobileNumberVerify === 'mobilenumber'} onChange={() => this.changePrimaryNumber('mobilenumber')} /> */}
                                        {
                                            this.state.peronalInfoForm.mobile.error && this.state.dontEdit ? <small className="text-danger mt-10">{this.state.peronalInfoForm.mobile.error}</small> : null
                                        }
                                           <div className="d-flex flex-row justify-content-start change-email-container">
                                            {
                                                !this.state.dontEdit ? null :
                                                    <div className="change-email-link clickable"  style={{marginTop: window.innerWidth < 990 && '45px'}}  onClick={this.showMobileModal}>Click here to {this.state.peronalInfoForm.mobile.value ? "change" : "add"} Phone Number</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-handle-2">
                                        {/* To remove padding add pb-un */}
                                        {/* <div className="float-control lg">
                                            {
                                                this.state.peronalInfoForm.contact.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.contact.error}</small> : null
                                            }
                                            <Form.Control size="lg" type="text" id="contact" name="contact" placeholder=" " value={this.state.peronalInfoForm.contact.value} onChange={this.onInputValidation} />
                                            <Form.Label htmlFor="contact">Alternate number</Form.Label>
                                        </div> */}
                                        {/* <Form.Check type="checkbox" className="text-muted" label="Use this number for verification" checked={this.state.mobileNumberVerify === 'alternatenumber'} onChange={() => this.changePrimaryNumber('alternatenumber')} /> */}
                                    </div>
                                </div>
                                <div className="row-handle d-lg-flex mt-3">
                                    <div className="col-handle-2">
                                        <Form.Label htmlFor="address1 fs-16"  className="required mt-3 text-bold">Address 1</Form.Label>
                                        <div className="float-control lg">
                                            {
                                                this.state.peronalInfoForm.address1.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.address1.error}</small> : null
                                            }
                                            <Form.Control className='inputColor fs-16'  size="lg" type="text" id="address1" name="address1" placeholder=" " value={this.state.peronalInfoForm.address1.value} onChange={this.onInputValidation} />
                                        </div>
                                    </div>
                                    <div className="col-handle-2">
                                        <Form.Label htmlFor="address2"  style={{marginTop: window.innerWidth > 990 && '13px'}} className='text-bold fs-16'>Address 2</Form.Label>
                                        <div className="float-control lg">
                                            {
                                                this.state.peronalInfoForm.address2.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.address2.error}</small> : null
                                            }
                                            <Form.Control size="lg" type="text" className="fs-16" id="address2" name="address2" placeholder="Apt, Bldg, Suite" value={this.state.peronalInfoForm.address2.value} onChange={this.onInputValidation} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row-handle d-lg-flex">
                                    <div className="col-handle-3">
                                        <Form.Label htmlFor="zipcode" className="required text-bold fs-16">Zip Code</Form.Label>
                                        <div className="float-control lg">
                                            {
                                                this.state.peronalInfoForm.zipcode.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.zipcode.error}</small> : null
                                            }
                                            <Form.Control size="lg" type="text" className="fs-16" id="zipcode" name="zipcode" placeholder=" " value={this.state.peronalInfoForm.zipcode.value} onChange={this.onInputValidation} />
                                        </div>
                                    </div>
                                    <div className="col-handle-3">
                                        <Form.Label htmlFor="state" className="required text-bold fs-16">State</Form.Label>
                                        <div className="float-control lg">
                                            {
                                                this.state.peronalInfoForm.state.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.state.error}</small> : null
                                            }
                                     <div>
                                            <Form.Select as="select" size="lg"  id="state" name="state" placeholder=" " value={this.state.peronalInfoForm.state.value} className={`fs-16 ${this.state.peronalInfoForm.state.value ? '' : 'normal-text'}`} onChange={this.onInputValidation} >
                                                <option className="d-none" value="">Select State</option>
                                                {
                                                    this.state.stateList.map((state, index) => <option value={state.state} key={`state_${index}`}>{state.state}</option>)
                                                }
                                            </Form.Select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-handle-3">
                                        <Form.Label htmlFor="city" className="required fs-16 text-bold">City</Form.Label>                
                                        <div className="float-control lg">
                                            {/* {
                                                this.state.peronalInfoForm.city.error ? <small className="text-danger mt-10">{this.state.peronalInfoForm.city.error}</small> : null
                                            } */}
                                            {this.state.showCityDropdown ? <div className='city-value'>
                                                {this.state.cityDropdownValue.map((elem, index) => (
                                                    <div className='pd-15' id={index} onClick={()=>{this.setCityValue(elem.city)}}>{elem.city}</div>
                                                ))}
                                            </div> : ""}
                                            <DebounceInput type='text' size="lg" id="city" name="city" placeholder="City" value={this.state.peronalInfoForm.city.value} className={`fs-16 ${this.state.peronalInfoForm.city.value ? 'form-control form-control-lg' : 'normal-text form-control form-control-lg'}`} onChange={this.onInputValidation} debounceTimeout={200}>
                                            </DebounceInput>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="row-handle d-lg-flex">
                                    <div className="col-handle-3">
                                        <div className="float-control lg">
                                            <Form.Select as="select" size="lg" id="country" name="country" placeholder=" ">
                                                <option>Country</option>
                                            </Form.Select>
                                            <Form.Label htmlFor="country" className="required">Country</Form.Label>
                                        </div>
                                    </div>
                                    <div className="col-handle-3">
                                        <div className="float-control lg">
                                            <Form.Select as="select" size="lg" id="timezone" name="timezone" placeholder=" ">
                                                <option>Time Zone</option>
                                            </Form.Select>
                                            <Form.Label htmlFor="timezone">Time Zone</Form.Label>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="checkbox-row">
                                    {/* <Form.Group controlId="additionalcost">
                                        <Form.Check type="checkbox" label="Hide additional shipping cost warning on the bidding page" />
                                    </Form.Group> */}
                                    {/* <Form.Group controlId="emails">
                                        <Form.Check type="checkbox" defaultChecked={this.state.checkBoxValue === 1 ? true : false} onChange={e => this.changeCheckboxvalue(e)} label="Do not send me any marketing emails for now" />
                                    </Form.Group> */}
                                </div>
                                {this.state.stateCityError ? <small className='text-danger' style={{ margin: "0 25px" }}>{this.state.stateCityError}</small> : this.state.showAddressError ? <small className='text-danger' style={{ margin: "0 25px" }}>{this.addressErrorMessage}</small> : '' }
                                <ToasterMessage className="alert-handle" ref={this.toasterMessage}></ToasterMessage>
                                <div className="buttons">
                                    <Button variant="outline-primary" style={{color: '#00263E', backgroundColor: '#868E961A', borderColor:'#868E961A'}}  onClick={() => {this.props.location?.state?.name =="bidscreen" ?  this.props.history.push(this.props.location.state.previouspath):this.navigate('/') }}>Cancel</Button>
                                    <Button variant="secondary" className='save-btn' onClick={this.updateProfile} disabled={!this.state.peronalInfoFormValid || this.state.loading || !this.state.cityStateIsValid || this.state.isSaveDisable}>
                                        {this.state.dontEdit ? 'Save' : 'Save'} {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}
                                    </Button>
                                    <div className="text-danger name-disable" style={{width:'50%', float: 'right', marginRight: '20%'}}>
                                        {this.state.errorMsg ? this.state.errorMsg : '' }
                                    </div>
                                </div>
                                
                                <div style={{ padding:  window.innerWidth > 790 && "15px", marginTop: "20px", marginBottom: "none !important"}}>
                                    <Datatable config={{ ...this.config }} ref={this.dataTable} />
                                </div>
                                <div style={{ textAlign:  window.innerWidth < 790 && "center", marginBottom: '5rem'}} ><Button variant="secondary" ref={this.headerButtonRef} onClick={this.showShippingModal}>Add Shipping Address</Button></div>
                                    {
                                        (!this.props.user.paymentcompleted && this.props.user.profilecompleted)? 
                                            <div className='d-flex flex-row'>
                                                <div className='d-flex flex-column flex-wrap p-3 mx-3 mt-5 mb-2 rounded col-handle-2' style={{ backgroundColor: '#e1e1e1' }}>
                                                    <span className='mb-3'>A secure payment method is needed to bid. Click continue to add payment method.</span>
                                                    {/* <Link to="/my-account/my-info/payment-methods/add"> */}
                                                <div>
                                                    <Button onClick={() => {
                                                        this.props.history.push(`/my-account/my-info/payment-methods/add`,
                                                            this.props.location.state?.previouspath ?
                                                                {
                                                                    previouspath: this.props.location.state?.previouspath,
                                                                    name: "bidscreen"
                                                                } : ''
                                                        );
                                                    }} variant='secondary'>Continue</Button>
                                                </div>
                                                    {/* </Link> */}
                                                </div>
                                            </div> 
                                            : 
                                            null
                                    }
                            </Form>
                        </div>
                }
                {/* dialog box for upprofileFormLoading profile image */}
                <Modal show={this.state.profileImage.modal} size="lg" animation={false} backdrop="static" onHide={this.onCancelImage}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body className="doka d-flex flex-column align-items-center justify-content-center">
                        <div className="doka-layout" style={{ width: '100%' }}>
                            <DokaImageEditor {...getEditorDefaults({ width: 130, height: 130 })}
                                {...this.customEditorDefaults} src={this.state.profileImage.tempImg}
                                onProcess={this.onSaveImage} />
                        </div>
                    </Modal.Body>
                </Modal>

                {/* modal to change email */}
                <Modal centered show={this.state.emailModal} size="md" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                       <div className="d-flex flex-column justify-content-center align-items-center w-100">
                            <div className="float-control w-75">
                                <div className="text" style={{lineHeight: '10px', top: '60px', textAlign: 'left'}}>
                                    {
                                        this.state.newEmail.error ? <small className="error">{this.state.newEmail.error}</small> : null
                                    }
                                    {
                                        this.state.newEmail.value === this.state.peronalInfoForm.email.value && this.state.isemailchanged ? <small className="error">Should not use same email</small> : null
                                    }
                                </div>
                                <Form.Control autoFocus type="text" id="new-email" name="newEmail" placeholder=" "
                                    disabled={(this.state.emailLoading || this.state.unverifiedemail === this.state.newEmail.value) && !this.state.isemailchanged} value={this.state.newEmail.value} onChange={this.onEmailChange} />
                                <label htmlFor="newEmail" className="required">New Email</label>
                            </div>
                            <div class="alert alert-primary d-flex align-items-center w-75" style={{ color: "#084298", backgroundColor: '#cfe2ff', borderColor: '#b6d4fe', fontSize: '0.7rem', marginTop: '2rem' }} role="alert">
                                <div> <i className="fa fa-info-circle" style={{ width: '10px', color: '#A50050', marginRight: '5px' }}></i>
                                    You will receive an email verification link to create a new password, please logout of your account before clicking on the verification email and setting a new password.
                                </div>
                            </div>
                  
                            {(this.state.showAppleid || this.state.showFacebookid || this.state.showGoogleid ) && <div class="alert alert-primary d-flex align-items-center w-75"  style={{color: "#084298", backgroundColor: '#cfe2ff', borderColor: '#b6d4fe', fontSize: '0.7rem'}} role="alert">
                                <div> <i className="fa fa-info-circle" style={{ width: '10px', color: '#A50050', marginRight: '5px' }}></i>
                                All Social media accounts linked to this account will be removed after email verification is completed.
                                </div>
                            </div>}

                            <div className="d-flex align-items-center justify-content-center">
                                <ToasterMessage className="alert-handle" ref={this.toasterMessageForNewEmail}></ToasterMessage>
                            </div>
                            <div className="d-flex align-items-center mt-4">
                                <Button variant="outline-dark btn-white mx-2 mt-2 mt-sm-0" onClick={() => this.hideEmailModal(false)}
                                    disabled={this.state.emailLoading}>Cancel</Button>
                                <div className="d-flex flex-row justify-content-center align-items-center mt-2 mt-sm-0">
                                    <Button variant="secondary mx-2" onClick={this.saveNewEmail}
                                        disabled={this.state.newEmail.error || this.state.emailLoading || !this.state.newEmail.value ||this.state.apiLoading || this.state.profileBtnDisable  || (this.state.newEmail.value === this.state.peronalInfoForm.email.value && this.state.isemailchanged)}>
                                        {this.state.unverifiedemail && !this.state.isemailchanged ? 'Edit' : 'Submit'}
                                        {this.state.emailLoading ? <Spinner as="span" size="sm" animation="border" role="status" aria-hidden="true"></Spinner> : null}
                                    </Button>
                                </div>
                                {
                                    this.state.unverifiedemail && !this.state.isemailchanged ?
                                        <div className="d-flex flex-row justify-content-center align-items-center mt-2 mt-sm-0">

                                            <Button variant="secondary mx-2"
                                                disabled={this.state.verifyLoading} onClick={this.verifyNewEmail}>Resend Verification Link</Button>
                                        </div> : null
                                }
                            </div>
                        </div> 
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.mobileModal} className="change-mobile-modal" onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Body>
                        <div className="profile-modal-close-icon clickable " onClick={this.hideMobileModal}></div>
                        <div className="d-flex flex-column justify-content-center align-items-center w-100 mt-3">
                            <div className="float-control" style={{ width: "90%" }}>
                                <div className="text" style={{lineHeight: 1, position: 'static', textAlign: 'left'}}>
                                    {
                                        this.state.mobile.newMobile.error ? <small className="error">{this.state.mobile.newMobile.error}</small> : null
                                    }
                                </div>
                                <Form.Control autoFocus type="text" id="newMobile" name="newMobile" placeholder=" "
                                    value={this.state.mobile.newMobile.value} onChange={this.onMobileChange} />
                                <label htmlFor="newMobile" className="required">New Mobile</label>
                            </div>
                            {this.state.isOtpSent &&
                                <div className="float-control" style={{ width: "90%" }}>
                                    <Form.Control autoFocus type="text" maxLength={6} id="otp" name="otp" placeholder="Enter OTP"
                                        value={this.state.mobile.otp.value} onChange={this.onMobileChange} />
                                    <label htmlFor="otp" className="required">OTP</label>
                                </div>
                            }
                            <div className="mt-2">
                                <div className="d-flex justify-content-around align-items-center mb-2">
                                    <div id="toaster" className={this.state.profileStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster" : ''}>
                                        <ToasterMessage ref={this.toasterMessageForNewMobile} className="alert-handle"></ToasterMessage>
                                    </div>
                                    <div>{this.state.profileStatus.show && !this.state.isOtpSent ? <Button className="text-info btn-email" onClick={() => this.generateOtp(this.state.loaderHandle)}>Retry</Button> : ''}</div>
                                </div>
                                {
                                    this.state.isOtpSent ?
                                        <div className="d-flex flex-column justify-content-center align-items-center flex-sm-row">
                                            {/* <Button variant="outline-dark btn-white mx-2" onClick={this.hideMobileModal} disabled={this.state.mobileLoading}>Cancel</Button> */}
                                            <Button variant="secondary" disabled={!this.state.mobile.valid || this.state.mobileLoading || this.state.apiLoading || this.state.profileBtnDisable || this.state.mobile.newMobile.error} onClick={() => { this.submitOtp() }}>
                                                Verify {this.state.peronalInfoForm.mobile.value && this.state.dontEdit ? '& Change' : ''} {
                                                    (this.state.mobileLoading && !this.state.resendOtp ) || this.state.apiLoading ?
                                                        <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                        null
                                                }
                                            </Button>
                                        </div> :
                                        <div className="d-flex justify-content-center align-items-center">
                                            {/* <Button variant="outline-dark btn-white mx-2" onClick={this.hideMobileModal} disabled={this.state.mobileLoading}>Cancel</Button> */}
                                            <Button variant="outline-dark btn-white mx-2" disabled={this.state.profileStatus.show || !this.state.mobile.valid || this.state.mobileLoading ||this.state.apiLoading || this.state.profileBtnDisable || this.state.mobile.newMobile.error} onClick={() => { this.generateOtp('call') }}>
                                                Call me {
                                                    this.state.mobileLoading && this.state.loaderHandle === 'call' ?
                                                        <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                        null
                                                }
                                            </Button>
                                            <Button variant="secondary" disabled={this.state.profileStatus.show || !this.state.mobile.valid || this.state.mobileLoading ||this.state.apiLoading || this.state.profileBtnDisable || this.state.mobile.newMobile.error } onClick={() => { this.generateOtp('sms') }}>
                                                Text me {
                                                    this.state.mobileLoading && this.state.loaderHandle === 'sms' ?
                                                        <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                        null
                                                }
                                            </Button>

                                        </div>
                                }
                                {
                                    this.state.isOtpSent ? <div className="mt-2 text-center">
                                        Not received? <span className="change-email-link clickable" onClick={() => this.resendOtp()}>
                                            Resend {
                                                this.state.resendOtp ?
                                                    <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                    null
                                            }
                                        </span>
                                    </div> : null
                                }
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                { /* modal to add billing address */ }
                <Modal id="shipping-modal" centered show={this.state.shippingModal} size="md" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Header className='header'>Shipping Address</Modal.Header>
                    <Modal.Body>
                        <Form className="shipping-modal">
                            <div className="row-handle d-lg-flex" >
                                <div className="col-handle-2">
                                    <div className="float-control lg">
                                        {
                                            this.state.shippingForm.address1.error ? <small className="text-danger mt-10">{this.state.shippingForm.address1.error}</small> : null
                                        }
                                        <Form.Control size="lg" type="text" id="address1" name="address1" placeholder=" " value={this.state.shippingForm.address1.value} onChange={this.shippingValidation} />
                                        <Form.Label htmlFor="address1" className="required">Address1</Form.Label>
                                    </div>
                                </div>
                                <div className="col-handle-2">
                                    <div className="float-control lg">
                                        {
                                            this.state.shippingForm.address2.error ? <small className="text-danger mt-10">{this.state.shippingForm.address2.error}</small> : null
                                        }
                                        <Form.Control size="lg" type="text" id="address2" name="address2" placeholder="Apt, Bldg, Suite" value={this.state.shippingForm.address2.value} onChange={this.shippingValidation} />
                                        <Form.Label htmlFor="address2">Address2</Form.Label>
                                    </div>
                                </div>
                            </div>
                            <div className="row-handle d-lg-flex">
                                <div className="col-handle-2">
                                    <div className="float-control lg">
                                        {
                                            this.state.shippingForm.zipcode.error ? <small className="text-danger mt-10">{this.state.shippingForm.zipcode.error}</small> : null
                                        }
                                        <Form.Control size="lg" type="text" id="zipcode" name="zipcode" placeholder=" " value={this.state.shippingForm.zipcode.value} onChange={this.shippingValidation} maxLength={5} />
                                        <Form.Label htmlFor="zipcode" className="required">Zipcode</Form.Label>
                                    </div>
                                </div>
                                <div className="col-handle-2">
                                    <div className={`float-control lg ${this.state.shippingStateCityError ? 'shipping-error' : ""}`}>
                                        {
                                            this.state.shippingForm.state.error ? <small className="text-danger mt-10">{this.state.shippingForm.state.error}</small> : null                                        
                                        }
                                        <Form.Select as="select" size="lg" id="state" name="state" placeholder=" " value={this.state.shippingForm.state.value} onChange={this.shippingValidation} >
                                            <option className="d-none" value="" style={{ fontSize: "10px" }}>Select State</option>
                                            {
                                                this.state.stateList.map((state, index) => <option style={{ fontSize: "13px" }} value={state.state} key={`state_${index}`}>{state.state}</option>)
                                            }
                                        </Form.Select> 
                                        <Form.Label htmlFor="state" className="required">State</Form.Label>
                                    </div>
                                </div>
                            </div>
                            <div className="row-handle d-lg-flex">
                                <div className="col-handle-2">
                                    <div className={`float-control lg ${this.state.shippingStateCityError ? 'shipping-error' : ""}`}>
                                        {/* {
                                            this.state.shippingForm.city.error ? <small className="text-danger mt-10">{this.state.shippingForm.city.error}</small> : null                                      
                                        } */}
                                        {this.state.shippingShowCityDropdown ? <div className='city-value' style={{ top : `${this.state.shippingShowCityDropdown ? "97%" : "80%"}`}}>
                                                {this.state.shippingCityDropdownValue.map((elem, index) => (
                                                    <div className='pd-15' id={index} onClick={()=>{this.setShippingCityValue(elem.city)}}>{elem.city}</div>
                                                ))}
                                            </div> : ""}
                                        <DebounceInput className='form-control form-control-lg' size="lg" type="text" id="city" name="city" placeholder=" " value={this.state.shippingForm.city.value} onChange={this.shippingValidation} debounceTimeout={200} />
                                        <Form.Label htmlFor="city" className="required">City</Form.Label>
                                    </div>
                                </div>
                                <div className="col-handle-2 d-flex">
                                    <div className='radio-center'>
                                        <div className={`d-lg-flex ${this.state.shippingForm.addresstype.value.toLowerCase() == "primary" ? 'disable-shipping' : ''}`}>
                                            <input type="radio" className="radio-btn" checked={this.state.shippingForm.addresstype.value == "Shipping" ? true : false} name="addresstype" id="Shipping" disabled={this.state.shippingForm.addresstype.value.toLowerCase() == "primary"} />
                                            <Form.Label htmlFor='shipping' className='ml-10'>Shipping</Form.Label>
                                        </div>
                                        {/* <div className="d-lg-flex">
                                            <input type="radio" checked={this.state.shippingForm.addresstype.value == "Billing"} name="addresstype" id="Billing" onChange={() => {this.shippingCheckboxValidation("Billing")}} className="radio-btn" />
                                            <Form.Label htmlFor='billing' className='ml-10'>Billing</Form.Label>
                                        </div> */}
                                    </div>
                                </div>
                                    {/* <div className="float-control lg">
                                        {
                                           this.state.shippingForm.country.error ? <small className="text-danger mt-10">{this.state.shippingForm.country.error}</small> : null
                                        }
                                        <Form.Control size="lg" type="text" id="country" name="country" placeholder=" " value={this.state.shippingForm.country.value} onChange={this.shippingValidation} />
                                        <Form.Label htmlFor="country" className="required">Country</Form.Label>
                                     </div> */}
                            </div>
                            {/* <div className="row-handle d-lg-flex">
                                <div className="col-handle-2 ml-23 pb-16">
                                    <div className="d-lg-flex">
                                        <input type="radio" checked={this.state.shippingForm.addresstype.value == "Shipping"} name="addresstype" id="Shipping" onChange={() => {this.shippingCheckboxValidation("Shipping")}} className="radio-btn" />
                                        <Form.Label htmlFor='shipping' className='ml-10'>Shipping</Form.Label>
                                    </div>
                                </div>
                                <div className="col-handle-2 ml-23 pb-16">
                                    <div className="d-lg-flex">
                                        <input type="radio" checked={this.state.shippingForm.addresstype.value == "Billing"} name="addresstype" id="Billing" onChange={() => {this.shippingCheckboxValidation("Billing")}} className="radio-btn" />
                                        <Form.Label htmlFor='billing' className='ml-10'>Billing</Form.Label>
                                    </div>
                                </div>
                            </div> */}
                            {this.state.shippingStateCityError ? <small className='text-danger' style={{ margin: "0 25px" }}>{this.state.shippingStateCityError}</small> : this.state.showShippingAddressError ? <small className='text-danger mb-20'>{this.addressErrorMessage}</small> : ''}
                            <ToasterMessage className="alert-handle" ref={this.shippingMessage}></ToasterMessage>
                            <div className="buttons d-flex" style={{justifyContent: "center", marginTop: this.state.shippingStateCityError ? '10px' : '20px'}}>
                                <Button style={{color: '#00263E', backgroundColor: '#868E961A', borderColor:'#868E961A'}}  variant="outline-primary w-20" onClick={this.hideShippingModal}>Cancel</Button>
                                <Button variant="secondary w-20 ml-10" disabled={!this.state.shippingFormValid || !this.state.shippingCityStateIsValid} onClick={this.saveShippingAddress}>Save</Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
                <Modal animation={false} centered show={this.state.showShippingErrorModal} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="body-content">
                            <div className="error-bg">
                                <p>{this.state.showShippingErrorMessage}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-center actions" style={{ marginTop: "2rem" }}>
                            <Button variant="secondary mx-2" onClick={() => { this.closeErrorModal() }}>Close</Button>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal animation={false} centered show={this.state.showProfileAddressValidateModal} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="body-content">
                            <div>
                                <small className='text-danger'>Your address does not meet our requirements. Did you mean to select one of the following addresses below? Please call or email CTBids Help if you have any questions.
                                -844-424-3435
                                -CTBIDSHelp@CaringTransitions.com</small>
                                <div className="col-handle-2 ml-23 pb-16 mt-20">
                                    <div className="d-flex flex-column">
                                        <div>
                                            <input type="radio" checked={this.state.selectedAddress == "entered"} name="addressradio" id="entered" onChange={() => { this.addressCheckboxValidation("entered") }} className="radio-btn"/>
                                            <Form.Label htmlFor='entered' className='text-secondary ml-10'><b>What you entered</b></Form.Label>
                                        </div>
                                        <div>
                                            { (this.state.peronalInfoForm.address1.value ? this.state.peronalInfoForm.address1.value + ', ' : '') + 
                                            (this.state.peronalInfoForm.address2.value ? this.state.peronalInfoForm.address2.value + ', ' : '') + 
                                            (this.state.peronalInfoForm.state.value ? this.state.peronalInfoForm.state.value + ', ' : '') + 
                                            (this.state.peronalInfoForm.city.value ? this.state.peronalInfoForm.city.value + ', ' : '') + 
                                            this.state.peronalInfoForm.zipcode.value }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-handle-2 ml-23 pb-16">
                                    <div className="d-flex flex-column">
                                        <div>
                                            <input type="radio" checked={this.state.selectedAddress == "recommended"} name="addressradio" id="recommended" onChange={() => { this.addressCheckboxValidation("recommended") }} className="radio-btn"/>
                                            <Form.Label htmlFor='recommended' className='text-secondary ml-10'><b>Recommended</b></Form.Label>
                                        </div>
                                        <div>  
                                            { (this.state.profileRecommendedAddress.address1.value ? this.state.profileRecommendedAddress.address1.value + ', ' : '') + 
                                            (this.state.profileRecommendedAddress.address2.value ? this.state.profileRecommendedAddress.address2.value + ', ' : '') + 
                                            (this.state.profileRecommendedAddress.state.value ? this.state.profileRecommendedAddress.state.value + ', ' : '') + 
                                            (this.state.profileRecommendedAddress.city.value ? this.state.profileRecommendedAddress.city.value + ', ' : '') + 
                                            this.state.profileRecommendedAddress.zipcode.value }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="buttons d-flex" style={{ justifyContent: "center" }}>
                            <Button variant="w-20" style={{color: '#00263E', backgroundColor: '#868E961A', borderColor:'#868E961A'}} onClick={this.cancelValidateAddress}>Cancel</Button>
                            <Button variant="secondary" className='w-20 ml-10' onClick={this.saveValidatedAddress}>Save</Button>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal animation={false} centered show={this.state.showShippingAddressValidateModal} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <div className="body-content">
                        <div>
                                <small className='text-danger'>Your address does not meet our requirements. Did you mean to select one of the following addresses below? Please call or email CTBids Help if you have any questions.
                                -844-424-3435
                                -CTBIDSHelp@CaringTransitions.com</small>
                                <div className="col-handle-2 ml-23 pb-16 mt-20">
                                    <div className="d-flex flex-column">
                                        <div>
                                            <input type="radio" checked={this.state.shippingSelectedAddress == "entered"} name="addressradio" id="entered" onChange={() => { this.shippingAddressCheckboxValidation("entered") }} className="radio-btn"/>
                                            <Form.Label htmlFor='entered' className='text-secondary ml-10'><b>What you entered</b></Form.Label>
                                        </div>
                                        <div>
                                            { (this.state.shippingForm.address1.value ? this.state.shippingForm.address1.value + ', ' : '') + 
                                            (this.state.shippingForm.address2.value ? this.state.shippingForm.address2.value + ', ' : '') + 
                                            (this.state.shippingForm.state.value ? this.state.shippingForm.state.value + ', ' : '') + 
                                            (this.state.shippingForm.city.value ? this.state.shippingForm.city.value + ', ' : '') + 
                                            this.state.shippingForm.zipcode.value}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-handle-2 ml-23 pb-16">
                                    <div className="d-flex flex-column">
                                        <div>
                                            <input type="radio" checked={this.state.shippingSelectedAddress == "recommended"} name="addressradio" id="recommended" onChange={() => { this.shippingAddressCheckboxValidation("recommended") }} className="radio-btn"/>
                                            <Form.Label htmlFor='recommended' className='text-secondary ml-10'><b>Recommended</b></Form.Label>
                                        </div>
                                        <div>  
                                            { (this.state.shippingRecommendedAddress.address1.value ? this.state.shippingRecommendedAddress.address1.value + ', ' : '') + 
                                            (this.state.shippingRecommendedAddress.address2.value ? this.state.shippingRecommendedAddress.address2.value + ', ' : '') + 
                                            (this.state.shippingRecommendedAddress.state.value ? this.state.shippingRecommendedAddress.state.value + ', ' : '') + 
                                            (this.state.shippingRecommendedAddress.city.value ? this.state.shippingRecommendedAddress.city.value + ', ' : '') + 
                                            this.state.shippingRecommendedAddress.zipcode.value}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="buttons d-flex" style={{ justifyContent: "center" }}>
                            <Button variant="outline-primary w-20" onClick={this.cancelShippingValidateAddress}>Cancel</Button>
                            <Button variant="secondary w-20 ml-10" onClick={this.saveShippingValidatedAddress}>Save</Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default connect(state => state)(PersonalInfo);